import { PDFPage } from "pdf-lib";
import { CommonDrawOptions, DocumentPlaceholder } from "../types";

export enum DatePlaceholderFormat {
  Date = "date",
  DateTime = "datetime",
}

export interface DatePlaceholderOptions {
  format: DatePlaceholderFormat;
  fontSize: number;
}

export const dateDraw = (
  page: PDFPage,
  placeholder: DocumentPlaceholder<DatePlaceholderOptions>,
  { font, locale, timeZone }: CommonDrawOptions
) => {
  const dateString = new Intl.DateTimeFormat(locale, {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: placeholder.options.format === DatePlaceholderFormat.DateTime ? "numeric" : undefined,
    minute: placeholder.options.format === DatePlaceholderFormat.DateTime ? "2-digit" : undefined,
    timeZone: timeZone,
  }).format(new Date());
  page.drawText(dateString, {
    x: placeholder.x * page.getSize().width,
    y: page.getSize().height - placeholder.y * page.getSize().height - placeholder.options.fontSize,
    size: placeholder.options.fontSize,
    font: font,
    lineHeight: placeholder.options.fontSize,
    maxWidth: placeholder.width * page.getSize().width,
  });
};
